import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawDecoHor1Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "deco-hor-1";
		this.icon = svg_deco_hor_1;
	}
}

window.customElements.define("inspx-draw-deco-hor-1-module", DrawDecoHor1Module);

const svg_deco_hor_1 = html`
<svg width="90" height="45" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
<g>
 <title>Layer 1</title>
 <rect fill="#ffffff" width="90" height="44.7166" id="svg_2" stroke="#aaa7a7"/>
 <line fill="none" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x1="30" y1="44.01581" x2="30" y2="0" id="svg_1" stroke="#444444"/>
 <line fill="none" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x1="60" y1="44.61649" x2="60" y2="0" id="svg_3" stroke="#444444"/>
 <text fill="#000000" stroke-width="0" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="91.05168" y="53.76739" id="svg_4" font-size="24" font-family="Sans-serif" text-anchor="middle" xml:space="preserve" transform="matrix(0.7865640806243794,0,0,0.8817506323334106,-25.8787736418564,-18.065804772613273) " stroke="#444444">DECO</text>
</g>
</svg>
`;
